/** @format */
import type { BaseResponse } from '@/utils';
import type { LoginParams, LoginResult, SysConfig, UserInfo, MenuInfo, SubSystems, AuthInfo } from './model';
import { request, requestRoot, getFrontEndConfigItemByCodeAndItemCode } from '@/utils';
import { getEnvUrlByUrl } from '@/utils/power';
import * as V1 from '@/api/version-v1';
export * from './model';
/**
 * @description 登录
 * @param {LoginParams} data
 * @returns
 */
export function login(authType = 'native', data: LoginParams) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return V1.login(authType, data);
	}
	let url = '/base/auth/login';
	if (authType === 'ldap') {
		url = '/base/auth/ldapLogin';
	}
	return request<BaseResponse<LoginResult>>(
		{
			url,
			headers: {
				isToken: false,
			},
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 退出方法
export function logout() {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return V1.logout();
	}
	return request({
		url: '/base/auth/logout',
		method: 'get',
	});
}

// 保存用户的系统主题
export function updateThemeStyle(data) {
	return request({
		url: '/system/user/updateThemeStyle',
		method: 'put',
		params: data,
	});
}

/**
 * 平台_系统配置_获取前端配置
 * @param params
 */
export async function getFrontEndConfig(params?: any) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return await V1.getFrontEndConfig(params);
	}
	try {
		const resFrontEndConfig = await request<SysConfig>(
			{
				url: '/base/system/sysConfig/getFrontEndConfig',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: true,
			},
		);
		//console.log(resFrontEndConfig, 'resFrontEndConfig');

		const logoUrl = getFrontEndConfigItemByCodeAndItemCode(resFrontEndConfig as any, 'login', 'headerLogo')?.itemValue;
		if (!logoUrl) {
			try {
				const url = '/power-front-base/frontend/json/oem.json';
				const res: any = await request(
					{
						url,
						method: 'get',
						params,
					},
					{
						isGetDataDirectly: false,
					},
				);
				//console.log(res, 'oemJson');
				const { oemJson } = res;

				const oemJsonObj = JSON.parse(oemJson || '{}');
				const sysConfigVos = [
					{
						id: '03',
						name: '登录页配置',
						code: 'login',
						itemNum: '1',
						itemName: '浏览器展示logo',
						itemCode: 'logo',
						itemType: 'image',
						itemValue: oemJsonObj.logo || '/power-front-base/frontend/images/default/logo.png',
						configType: 'frontEnd',
					},
					{
						id: '04',
						name: '登录页配置',
						code: 'login',
						itemNum: '2',
						itemName: '页面Title',
						itemCode: 'title',
						itemType: 'input',
						itemValue: oemJsonObj.title || '一体化应用平台',
						configType: 'frontEnd',
					},
					{
						id: '05',
						name: '登录页配置',
						code: 'login',
						itemNum: '3',
						itemName: '备案信息',
						itemCode: 'copyright',
						itemType: 'input',
						itemOptions: null,
						itemValue: oemJsonObj.copyright || '',
						configType: 'frontEnd',
					},
					{
						id: '06',
						name: '登录页配置',
						code: 'login',
						itemNum: '4',
						itemName: '首页头部Logo',
						itemCode: 'headerLogo',
						itemType: 'image',
						itemOptions: null,
						itemValue: oemJsonObj.logo || '/power-front-base/frontend/images/default/logo.png',
						configType: 'frontEnd',
					},
					{
						id: '09',
						createBy: null,
						createTime: null,
						updateBy: '1',
						updateTime: '2023-06-08 09:14:59',
						deleted: null,
						serNum: '2',
						name: '登录页配置',
						code: 'login',
						itemNum: '7',
						itemName: '密码错误次数锁定账户',
						itemCode: 'loginFailTimesOfLockAccount',
						itemType: 'input',
						itemOptions: null,
						itemValue: '5',
						configType: 'frontEnd',
						fileId: null,
						fileName: null,
						filePath: null,
					},
					{
						id: '19',
						createBy: null,
						createTime: null,
						updateBy: '1',
						updateTime: '2023-06-08 09:14:59',
						deleted: null,
						serNum: '2',
						name: '登录页配置',
						code: 'login',
						itemNum: '8',
						itemName: '公司名称',
						itemCode: 'companyName',
						itemType: 'input',
						itemOptions: null,
						itemValue: '科技股份有限公司',
						configType: 'frontEnd',
						fileId: null,
						fileName: null,
						filePath: null,
					},
					{
						id: '20',
						name: '登录页配置',
						code: 'login',
						itemNum: '9',
						itemName: '登录背景图',
						itemCode: 'backgroundImage',
						itemType: 'image',
						itemOptions: null,
						itemValue: oemJsonObj.signinBackground || '/power-front-base/frontend/images/default/signinBackground.png',
						configType: 'frontEnd',
					},
				];

				const loginObj = {
					code: 'login',
					name: '登录页配置',
					sysConfigVos,
				};
				const resFrontEndConfig = [loginObj];
				//console.log(loginObj, 'loginObj');

				return resFrontEndConfig;
			} catch (error) {
				// console.log('error', error);
				throw new Error('【power--runtime】获取网站配置出错。');
			}
		}

		return resFrontEndConfig;
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取网站配置出错。');
	}
}

/**
 * 获取用户是否已登录
 * @param params
 */
export async function getLoggedIn(params?: any) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return await V1.getLoggedIn(params);
	}
	try {
		if (window.location.href.indexOf('/auth/oauth2Login?code') > -1 || window.location.href.indexOf('?ticket=') > -1) {
			// 已登录
			//console.log('loggedIn', true);

			return true;
		}
		const loggedIn: any = await request(
			{
				url: '/base/user/context/checkToken',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: true,
			},
		);
		//console.log('loggedIn', loggedIn);

		return loggedIn;
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取 用户是否登录 信息出错。');
	}
}

/**
 * 获取用户信息
 * @param params
 */
export async function getUserInfo(params?: any) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return await V1.getUserInfo(params);
	}
	try {
		return await request<UserInfo>(
			{
				url: '/base/user/context/getUser',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: true,
			},
		);
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取用户信息出错。');
	}
}

/**
 * 获取获取子系统信息
 * @param params
 */
export async function getSubSystem(params?: any) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return await V1.getSubSystem(params);
	}
	try {
		const { url, ...otherParams } = params;
		let realUrl = url;
		if (!realUrl) {
			realUrl = params.isMobile ? '/base/user/context/getAppSubSystem' : '/base/user/context/getSubSystem';
		}
		return await request<SubSystems>(
			{
				url: realUrl,
				method: 'get',
				params: {
					...otherParams,
				},
			},
			{
				isGetDataDirectly: true,
			},
		);
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取获取子系统信息出错。');
	}
}

/**
 * 获取当前系统菜单
 * @param params
 */
export async function getMenu(params?: any) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return await V1.getMenu(params);
	}
	try {
		let { url = '/power-api/base/user/context/getMenu', ...otherParams } = params;
		url = getEnvUrlByUrl(url);
		return await requestRoot<MenuInfo>(
			{
				url,
				method: 'get',
				params: otherParams,
			},
			{
				isGetDataDirectly: true,
			},
		);
	} catch (error) {
		// console.log('error', error);
		throw new Error('【power--runtime】获取当前系统菜单出错。');
	}
}

export async function requestDataBeforeLogin() {
	return await Promise.all([getFrontEndConfig(), getLoggedIn()]);
}

export async function requestDataAfterLogin(params = { getSubSystemParams: {} }) {
	return await Promise.all([getUserInfo(), getSubSystem(params.getSubSystemParams)]);
}

export async function getAuthInfo(
	params = {
		_t: new Date().getTime(),
	},
) {
	try {
		return await request<AuthInfo>(
			{
				url: '/auth/authType',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: true,
			},
		);
	} catch (error) {
		console.log('error', error);
		throw new Error('【power--runtime】获取认证信息出错。');
	}
}

export async function getCasLoginInfo(params = {}) {
	try {
		return await request<BaseResponse>(
			{
				url: '/auth/casLogin',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: false,
			},
		);
	} catch (error) {
		console.log('error', error);
		throw new Error('【power--runtime】获取 cas 登录 信息出错。');
	}
}

export async function getOauth2LoginInfo(params = {}) {
	try {
		return await request<BaseResponse>(
			{
				url: '/auth/oauth2Login',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: false,
			},
		);
	} catch (error) {
		console.log('error', error);
		throw new Error('【power--runtime】获取 oauth2 登录 信息出错。');
	}
}

export async function getOauth2Login(params = {}) {
	try {
		return await request<BaseResponse>(
			{
				url: '/auth/oauth2/index',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: false,
			},
		);
	} catch (error) {
		console.log('error', error);
		throw new Error('【power--runtime】跳转 oauth2 登录页面出错。');
	}
}

export async function getAuthSilent2Config(params = {}) {
	try {
		return await request<{ username: string; password: string; targeturl: string }>(
			{
				url: '/power-front-base/frontend/json/auth-silent2.json',
				method: 'get',
				params,
			},
			{
				isGetDataDirectly: true,
			},
		);
	} catch (error) {
		console.log('error', error);
		throw new Error('【power--runtime】获取默认 auth-silent2 配置出错。');
	}
}

export async function getCommonjson(params = {}) {
	return await request<{ notredirect: any; whitelist: any }>(
		{
			url: `/power-front-base/frontend/json/${window.pData.env.VITE_NODE_ENV}/commonjson.json`,
			method: 'get',
			params,
		},
		{
			isGetDataDirectly: true,
		},
	);
}

export async function findTreeDataWithNoRoot() {
	const res = await request<any>({
		url: '/base/system/sysCatType/findTreeDataWithNoRoot',
		type: 'get',
		params: {
			categoryKey: 'DIC_TYPE',
		},
	});
	const resp: {
		label: string;
		value: string;
	}[] = res.map((p) => ({
		label: p.name,
		value: p.typeKey,
		...p,
	}));
	const cache = window.sessionStorage.getItem('dictCache') || '{}';

	const cacheObj = JSON.parse(cache);
	cacheObj['dictCacheAll'] = resp;

	window.sessionStorage.setItem('dictCache', JSON.stringify(cacheObj));
	return resp;
}
